module.exports = __webpack_public_path__ + "static/img/MX.02b0a0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/MX.svg
// module id = L2j/
// module chunks = 66